import { render, staticRenderFns } from "./contactCard.vue?vue&type=template&id=6742f462&scoped=true&"
import script from "./contactCard.vue?vue&type=script&lang=js&"
export * from "./contactCard.vue?vue&type=script&lang=js&"
import style0 from "./contactCard.vue?vue&type=style&index=0&id=6742f462&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6742f462",
  null
  
)

export default component.exports